import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from 'app/common/components/Modal'
import PlainButton from 'app/common/ui-next/plain-button'

import SuccessIcon from './icons/success-order.svg'
import styles from './SuccessModal.module.scss';

type Props = {
  onSuccess?: () => void
  isOpen: boolean
  preliminary: boolean
}

const SuccessModal = ({ onSuccess, isOpen, preliminary }: Props) => {
  const { t } = useTranslation('cafeteria')

  const handleAccept = useCallback(
    (e) => {
      e.preventDefault()
      onSuccess?.()
    },
    [onSuccess],
  )

  return (
    <Modal isOpen={isOpen}>
      <div className={styles.root}>
        <SuccessIcon className={styles.icon} />
        <div className={styles.head}>
          {preliminary
            ? t('order_form_order_created_pre', 'Предварительный заказ создан')
            : t('order_form_order_created', 'Заказ создан')}
        </div>
        <PlainButton onClick={handleAccept}>{'Готово'}</PlainButton>
        <div className={styles.text}>
          {preliminary
            ? t(
                'order_form_preorder_sent',
                'Предварительный заказ отправлен на обработку. Ожидайте уведомление о готовности и после можете получить ваш заказ. Приятного аппетита!',
              )
            : t(
                'order_form_order_order_sent',
                'Заказ направлен в обработку. Дождитесь уведомления о принятии и после можете получить ваш заказ. Приятного аппетита!',
              )}
        </div>
      </div>
    </Modal>
  )
}

export default SuccessModal
